import React from "react";
import { Heading } from "../../Heading";
import { ImgV2 } from "../../ImgV2";
export const Items = ({ iconUrl, subTitle, title }) => (React.createElement("div", { className: "items__root" },
    React.createElement(ImgV2, { src: iconUrl }),
    React.createElement(Heading, { design: "h5-bold" }, title),
    subTitle && React.createElement("p", { className: "p-regular", dangerouslySetInnerHTML: {
            __html: subTitle
        } })));
